class KxProductMotion extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.abort = new AbortController();
    const opts = {signal: this.abort.signal};
    this.video.addEventListener('click', e => e.stopPropagation(), opts);
    this.video.addEventListener('playing', () => {
      this.video.style.opacity = '1';
      this.video.style.pointerEvents = 'auto';
    }, opts);
    this.video.addEventListener('error', () => this.fallback(), opts);
    this.motion.addEventListener('change', () => {
      if (this.motion.matches) this.fallback(); else if (this.visible) this.start();
    }, opts);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.video.pause(); else if (this.visible) this.start();
    }, opts);
    this.observer = new IntersectionObserver(entries => {
      this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.6;
      if (this.visible) this.start(); else this.video.pause();
    }, {threshold:[0,0.6]});
    this.observer.observe(this);
  }
  async start() {
    if(this.motion.matches || navigator.connection?.saveData || document.hidden) return;
    if(!this.loaded) {
      this.video.querySelectorAll('source').forEach(s => s.src = s.dataset.src);
      this.video.muted = true;
      this.video.load();
      this.loaded = true;
    }
    try { await this.video.play(); } catch { this.fallback(); }
  }
  fallback() {
    this.video.pause();
    this.video.style.opacity = '0';
    this.video.style.pointerEvents = 'none';
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    this.abort?.abort();
    this.video?.pause();
  }
}
if(!customElements.get('kx-product-motion')) customElements.define('kx-product-motion', KxProductMotion);
